import React, { useEffect, useState } from 'react';
import './WhatsAppBanner.css';

const WhatsAppBanner = () => {
  const [status, setStatus] = useState(null); // { online: bool, openHour, closeHour }

  useEffect(() => {
    let cancelled = false;
    fetch('/api/settings/public')
      .then(r => r.json())
      .then(d => {
        if (cancelled || !d.success || !d.businessHours) return;
        const { openHour, closeHour } = d.businessHours;
        const now = new Date().getHours();
        setStatus({ online: now >= openHour && now < closeHour, openHour, closeHour });
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return (
    <section className="wa-banner" aria-label="Get your reading">
      <div className="wa-banner__inner">
        <div className="wa-banner__text">
          <h2 className="wa-banner__title">Ready to Discover Your Destiny?</h2>
          <p className="wa-banner__sub">
            Chat directly with our VTD certified astrologers. Fixed price. No surprises.
          </p>
          {status && (
            <p className={`wa-banner__status ${status.online ? 'wa-banner__status--online' : 'wa-banner__status--offline'}`}>
              {status.online
                ? <>🟢 Team is online now</>
                : <>🌙 We open at {formatHour(status.openHour)} — leave a message anytime</>}
            </p>
          )}
        </div>
        <a href="/chat" className="wa-banner__btn">
          <ChatIcon />
          <span>Get Your Reading</span>
        </a>
      </div>
    </section>
  );
};

function formatHour(h) {
  if (h === 0)  return '12 AM';
  if (h === 12) return '12 PM';
  if (h < 12)   return `${h} AM`;
  return `${h - 12} PM`;
}

const ChatIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor" aria-hidden="true">
    <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>
  </svg>
);

export default WhatsAppBanner;
